/*
 * Rooté Bloom customer stories lightbox.
 *
 * Drives the dialog in sections/rb-customer-stories.liquid. The carousel itself is
 * Ella's <swiper-component>, so nothing here touches slides, autoplay or dragging —
 * this only opens a screenshot large enough to read, and steps between them.
 *
 * The card buttons are read from the DOM in source order rather than from Swiper's
 * slide list, because `loop` clones slides and the clones would show up twice.
 */

if (!customElements.get('rb-customer-stories')) {
  class RbCustomerStories extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-dialog]');
      this.dialogImage = this.querySelector('[data-dialog-image]');
      this.countNode = this.querySelector('[data-count]');
      this.index = 0;
      this.lastOpener = null;

      /* Swiper's loop clones carry the same data-position; the original is the first. */
      this.cards = Array.from(this.querySelectorAll('[data-open]')).filter(
        (card, position, all) =>
          all.findIndex((other) => other.dataset.position === card.dataset.position) === position
      );

      if (!this.dialog || !this.dialogImage || this.cards.length === 0) return;

      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-open]');
        if (opener) this.open(opener);
      });

      this.querySelector('[data-close]')?.addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));

      /*
       * Focusing on the `close` event itself lands while the dialog is still the focus
       * scope, and focus stays on the close button. A frame later the dialog is out of
       * the top layer and the card takes it.
       */
      this.dialog.addEventListener('close', () => {
        requestAnimationFrame(() => this.lastOpener?.focus());
      });

      /* A native dialog closes on a backdrop click only if we ask it to. */
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(-1);
        }
      });
    }

    open(opener) {
      const position = this.cards.findIndex(
        (card) => card.dataset.position === opener.dataset.position
      );
      if (position === -1) return;

      this.lastOpener = opener;
      this.show(position);
      this.dialog.showModal();
    }

    step(delta) {
      const total = this.cards.length;
      this.show((this.index + delta + total) % total);
    }

    show(position) {
      const card = this.cards[position];
      if (!card) return;

      this.index = position;
      this.dialogImage.src = card.dataset.full || '';
      this.dialogImage.alt = card.dataset.label || '';

      if (this.countNode) {
        this.countNode.textContent = `${position + 1} / ${this.cards.length}`;
      }
    }
  }

  customElements.define('rb-customer-stories', RbCustomerStories);
}
